'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collections = function (_Component) {
  (0, _inherits3.default)(Collections, _Component);

  function Collections() {
    (0, _classCallCheck3.default)(this, Collections);
    return (0, _possibleConstructorReturn3.default)(this, (Collections.__proto__ || (0, _getPrototypeOf2.default)(Collections)).apply(this, arguments));
  }

  (0, _createClass3.default)(Collections, [{
    key: 'render',
    value: function render() {
      var styles = require('./Collections.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.collections },
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u1ED9 s\u01B0u t\u1EADp'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.activityTotal },
            '6 b\u1ED9 s\u01B0u t\u1EADp'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.activitySort },
            _react2.default.createElement(
              _reactBootstrap.FormControl,
              {
                componentClass: 'select',
                style: {
                  width: '174px',
                  textAlign: 'right',
                  height: '40px',
                  fontWeight: 'normal'
                }
              },
              _react2.default.createElement(
                'option',
                { value: 'new' },
                'M\u1EDBi nh\u1EA5t'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.activitySort,
              style: {
                marginRight: '12px',
                fontSize: '14px',
                lineHeight: '40px'
              }
            },
            'S\u1EAFp x\u1EBFp'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.collectionList },
          _react2.default.createElement(
            _reactBootstrap.Row,
            { style: { marginRight: 0 } },
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 4, sm: 6 },
              _react2.default.createElement(_components.CollectionCard, null)
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 4, sm: 6 },
              _react2.default.createElement(_components.CollectionCard, null)
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 4, sm: 6 },
              _react2.default.createElement(_components.CollectionCard, null)
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 4, sm: 6 },
              _react2.default.createElement(_components.CollectionCard, null)
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 4, sm: 6 },
              _react2.default.createElement(_components.CollectionCard, null)
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 4, sm: 6 },
              _react2.default.createElement(_components.CollectionCard, null)
            )
          )
        )
      );
    }
  }]);
  return Collections;
}(_react.Component);

exports.default = Collections;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountManagement/Collections.js
// module id = 1503
// module chunks = 0